export default {
  metaDescription: 'Stay up to date with the latest news, project updates and industry insights from PT Tokki Engineering and Fabrication (TEF).',
  pageTitle: 'News & Blog',
  readMore: 'READ MORE',
  byAdmin: 'By Admin',
  empty: 'No news or blog articles yet.',
};
